import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import type { DragEvent, ReactNode } from "react";
import { useStoredOpen } from "../../../ui/layout/useStoredOpen";

interface SidebarShelfProps {
  /** Where this browser keeps it open or closed. */
  readonly storageKey: string;
  /** The heading, with its count. */
  readonly title: string;
  /** While a Thread is dragged over it: where it can be dropped. */
  readonly dropZone?: { onDragOver: (event: DragEvent) => void; onDrop: (event: DragEvent) => void } | undefined;
  /** The rows, given whether the shelf is open. */
  readonly children: (open: boolean) => ReactNode;
}

/**
 * One of the Threads sidebar's shelves, as T3 Code's: a group under the active list,
 * collapsed until opened, kept open or closed in this browser (F44, F108).
 */
export default function SidebarShelf({ storageKey, title, dropZone, children }: SidebarShelfProps) {
  const [open, setOpen] = useStoredOpen(storageKey, false);
  return (
    <section {...dropZone} className={dropZone === undefined ? undefined : "rounded outline-dashed outline-1"}>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => { setOpen(!open); }}
        className="app-text-muted flex w-full items-center gap-1 rounded px-2 py-1 text-left text-xs font-semibold hover:underline"
      >
        {open ? <ChevronDownIcon className="h-3 w-3" aria-hidden="true" /> : <ChevronRightIcon className="h-3 w-3" aria-hidden="true" />}
        {title}
      </button>
      {children(open)}
    </section>
  );
}
